export default {
  namespaced: true,
  state () {
    return {
      problem_ids: [],
      detail: null
    }
  },
  getters: {
    problem_ids (state) {
      return state.problem_ids
    },
    detail (state) {
      return state.detail
    }
  },
  mutations: {
    setProblemIds (state, ids) {
      state.problem_ids = ids
    },
    setDetail (state, detail) {
      state.detail = detail
    },
    addProblemField (state, fieldName) {
      state.detail.have_problem_fields.push(fieldName)
    }
  },
  actions: {
    setProblemIds ({commit}, ids) {
      commit('setProblemIds', ids)
    },
    setDetail ({commit}, detail) {
      commit('setDetail', detail)
    },
    addProblemField ({commit}, fieldName) {
      commit('addProblemField', fieldName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Repack/store.js